import React from "react";
import {
  FaBolt,
  FaCheckCircle,
  FaClock,
  FaPlus,
  FaSyncAlt,
  FaTasks,
} from "react-icons/fa";

export default function TaskKanbanHeader({
  board,
  stats,
  loading,
  onRefresh,
  onOpenCreate,
}) {
  return (
    <header className="px-4 py-3 text-white">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-2xl bg-white/10 text-sky-300 shadow-lg ring-1 ring-white/15">
              <FaTasks />
            </div>

            <div className="min-w-0">
              <h1 className="truncate text-xl font-bold tracking-tight sm:text-2xl">
                {board?.title || "Tâches à réaliser"}
              </h1>
              <p className="mt-0.5 text-xs font-medium text-white/60 sm:text-sm">
                Pilotage des corrections, évolutions, clients, applications et priorités.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex h-10 items-center gap-2 rounded-xl border border-white/15 bg-white/10 px-3 text-sm font-bold text-white shadow-sm transition hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>

          <button
            type="button"
            onClick={onOpenCreate}
            className="inline-flex h-10 items-center gap-2 rounded-xl bg-sky-300 px-4 text-sm font-bold text-slate-950 shadow-lg shadow-sky-300/20 transition hover:bg-sky-200"
          >
            <FaPlus />
            Nouvelle tâche
          </button>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <HeaderStat
          label="Cartes"
          value={stats?.total || 0}
          icon={FaTasks}
          tone="text-sky-300"
        />
        <HeaderStat
          label="Urgentes"
          value={stats?.urgent || 0}
          icon={FaBolt}
          tone="text-yellow-300"
        />
        <HeaderStat
          label="En retard"
          value={stats?.late || 0}
          icon={FaClock}
          tone="text-red-300"
        />
        <HeaderStat
          label="Terminées"
          value={stats?.done || 0}
          icon={FaCheckCircle}
          tone="text-emerald-300"
        />
      </div>
    </header>
  );
}

function HeaderStat({ label, value, icon: Icon, tone }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.08] px-3 py-2 shadow-sm backdrop-blur">
      <div className="flex items-center justify-between gap-2">
        <div>
          <div className="text-lg font-bold leading-none">{value}</div>
          <div className="mt-1 text-[11px] font-bold uppercase tracking-wide text-white/55">
            {label}
          </div>
        </div>

        <Icon className={`text-lg ${tone}`} />
      </div>
    </div>
  );
}